import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ec32b6aa&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=ec32b6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec32b6aa",
  null
  
)

export default component.exports